export const getRgbCodes = (color) => {
  if (color?.includes('gradient')) {
    const rgbMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (rgbMatch) {
      return [
        parseInt(rgbMatch[1]),
        parseInt(rgbMatch[2]),
        parseInt(rgbMatch[3]),
      ];
    }
    return [];
  }

  const result = color?.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);

  if (!result) {
    return [];
  }
  const red = isFinite(parseInt(`${result[1]}`, 16))
    ? parseInt(`${result[1]}`, 16)
    : 0;
  const green = isFinite(parseInt(`${result[2]}`, 16))
    ? parseInt(`${result[2]}`, 16)
    : 0;
  const blue = isFinite(parseInt(`${result[3]}`, 16))
    ? parseInt(`${result[3]}`, 16)
    : 0;

  return [red, green, blue];
};

const getRgbWithOpacity = (color, opacity = 0.1) => {
  const [r, g, b] = getRgbCodes(color);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

const getTextColorForBackground = (bgColor) => {
  const [r, g, b] = getRgbCodes(bgColor);

  // Calculate the YIQ value (brightness formula)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Return black for bright backgrounds, and white for dark backgrounds
  return yiq >= 128 ? '#000000' : '#FFFFFF';
};

export const getThemeDetails = ({ themeData }) => {
  const defaultPrimaryColor = '#F95D2D';
  const defaultConfig = {
    primaryColor: defaultPrimaryColor,
    secondaryColor: '#FBF6EE',
    logoUrl: 'https://assets-1.kula.ai/images/logo/logo-1-b@3x.png',
    textColor: '#fff',
    tertiaryColor: getRgbWithOpacity(defaultPrimaryColor, 0.1),
  };
  return {
    primaryColor:
      themeData?.data?.theme?.primary?.backgroundColor ||
      defaultConfig.primaryColor,
    secondaryColor:
      themeData?.data?.theme?.secondary?.backgroundColor ||
      defaultConfig.secondaryColor,
    logoUrl: themeData?.data?.logo_url || defaultConfig.logoUrl,
    textColor: themeData?.data?.theme?.primary?.backgroundColor
      ? getTextColorForBackground(
          themeData?.data?.theme?.primary?.backgroundColor
        )
      : defaultConfig.textColor,
    tertiaryColor: themeData?.data?.theme?.primary?.backgroundColor
      ? getRgbWithOpacity(themeData?.data?.theme?.primary?.backgroundColor, 0.1)
      : defaultConfig.tertiaryColor,
  };
};

export const assessmentErrorMessages = {
  err_attachment_size_limit_exceeded:
    'You can upload files up to 10 MB in size',
  err_attachment_count_limit_exceeded:
    'You can upload a maximum of 10 files at a time',
  err_attachment_type_invalid:
    'This file type isn’t supported. Try compressing the file and uploading it as a zip file',
  err_reviewer_already_responded:
    'This scorecard has been submitted by the reviewer already',
  err_questions_not_editable_once_submitted:
    'Unable to edit this scorecard because a reviewer has already filled it out',
  err_assessment_not_found:
    'Unable to start the assessment as it has not been sent yet',
  err_assessment_already_started:
    'Unable to start the assessment as it has been started already',
  err_assessment_cancelled:
    'This assessment has been canceled. Reach out to your recruiter for assistance',
  err_assessment_already_submitted:
    'This assessment has been submitted already. Reach out to your recruiter for assistance',
  err_assessment_not_yet_started:
    'Unable to submit the assessment as it has not been started yet',
  err_assessment_submission_not_found: 'No assessment submission found',
  err_attachment_id_missing: 'Unable to delete the attachment',
  err_attachment_not_found:
    'Unable to delete the attachment as it has been deleted already',
  err_uploading_attachment: 'Unable to upload the attachment. Try again later',
  err_unable_to_save_assessment_submission:
    'Unable to auto-save the assessment. Try again later',
  err_unable_to_submit_assessment:
    'Unable to submit the assessment. Try again later',
  err_text_is_too_long: 'You can add a maximum of 16,000 characters',
};
